import { createNameContext } from '@showroomjs/ui';
import React from 'react';
const CodeFrameContext = createNameContext('CodeFrameContext', {
    showDeviceFrame: true,
    frameDimensions: [],
});
export const CodeFrameContextProvider = CodeFrameContext.Provider;
export const useCodeFrameContext = () => React.useContext(CodeFrameContext);
//# sourceMappingURL=code-frame-context.js.map